export default __webpack_public_path__ + "static/finding-uid-ios-8b627b9d73325ee5a7532c1f2970804b.gif";